import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getWhatsAppMetaScopesCacheKey } from "./constants";
import type { WhatsAppMetaScopes } from "./types";

export const getWhatsAppMetaScopes = reactQueryFetcherAdapter(
  getWhatsAppMetaScopesCacheKey,
  async (signal, appGroupId: string, messagingServiceId: string): Promise<WhatsAppMetaScopes> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/meta_api_scopes/${messagingServiceId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
